/** Layout & top bar (English) */
export default {
  layout: {
    manager: 'Manager',
    managerNotSelected: 'No manager',
    switchingToManager: 'Switching to {name}…',
    switchedToManager: 'Switched to {name}',
    selectManagerTitle: 'Select manager',
    managerSearchPlaceholder: 'Search name or address',
    managerSearchEmpty: 'No matching manager',
    defaultBadge: 'Default',
    currentBadge: 'Current',
    switchTo: 'Switch to',
    setAsDefault: 'Set as default',
    setDefaultManagerConfirm: 'Set 「{name}」 as the default manager?',
    setDefaultManagerHint: 'Confirm',
    setDefaultManagerSuccess: 'Default manager set successfully',
    currentPlatform: 'Current platform',
    enterFullscreen: 'Enter fullscreen',
    exitFullscreen: 'Exit fullscreen',
    settings: 'Preferences',
    profile: 'Profile',
    changePassword: 'Change password',
    logout: 'Log out',
    energyScreen: 'Energy Screen',
    manual: 'User manual',
    langZh: '中文',
    langEn: 'English',
    langShortZh: 'CN',
    langShortEn: 'EN',
    defaultUser: 'Admin',
    langSwitchTitle: 'Click to switch language'
  },
  tagsView: {
    more: 'More',
    tagManage: 'Tabs',
    tagCount: '{n} tabs',
    searchPlaceholder: 'Search tab…',
    visibleNow: 'Visible',
    moreTags: 'Hidden',
    refreshTip: 'Refresh',
    closeOthersTip: 'Close others'
  }
}
